import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import ProgressHeader from './ProgressHeader';
import StepperNav from './Stepper';
import { useWizard } from '../hooks/WizardProvider';
import { getStepById } from '../utils/onboardingSteps.config';
import useOnboardingSx from '../hooks/useOnboardingSx';

export default function Layout({ children }) {
  const sx = useOnboardingSx();
  const {
    showResumeBanner,
    resumeStep,
    currentStep,
    dismissResumeBanner,
    isInitializing,
    saveError,
  } = useWizard();
  const resumeTitle = getStepById(resumeStep)?.title ?? 'setup';

  if (isInitializing) {
    return (
      <Box sx={sx.loadingBox}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={sx.pageRoot}>
      <ProgressHeader />
      {saveError && (
        <Alert severity="error" sx={sx.alert}>
          {saveError}
        </Alert>
      )}
      {showResumeBanner && currentStep === resumeStep && resumeStep > 1 && (
        <Alert severity="info" onClose={dismissResumeBanner} sx={sx.alert}>
          Continue your setup from <strong>{resumeTitle}</strong>. Your previous progress has been
          restored.
        </Alert>
      )}
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <StepperNav />
        </Grid>
        <Grid item xs={12} md={9}>
          {children}
        </Grid>
      </Grid>
    </Box>
  );
}
